export const getCardInitials = cardType => {
    switch (cardType) {
        case 'mastercard':
        case 'maestro':
            return 'MC';

        case 'american-express':
            return 'AMEX';

        case 'discover':
            return 'DISC';

        case 'diners-club':
            return 'DC';

        default:
            return cardType.toUpperCase();
    }
};
